export default __webpack_public_path__ + "static/media/stars.fb95e3d1.png";